import { images } from '../constants';

const home = [
    {    
        id: 1,
        image: images.home1,
        title: '聰明支付真方便',
        content: '我們整合您在大潤發賣場與周邊店家的消費，加入會員並綁頂信用卡，不需經過繳費機就可離場。',
    },
    {
        id: 2,
        image: images.home2,
        title: '您是大潤發聯名卡會員嗎？',
        content: '賣場消費自動折抵，不需要再過繳費機掃哪。綁訂支付方式可享受VIP尊榮，直接離場。', 
    },
    { 
        id: 3,
        image: images.home3,
        title: '免費折抵時數即時查詢！',
        content: '加入會員，每筆消費折抵輕鬆掌握。只要進到本服務就可以進行查詢。',     
    },

];

export default home;